module.exports = __webpack_public_path__ + "img/login_bg.dba74e0c.jpg";